function Unauthorized() {
    return (
        <div className='mt-5 text-center'>Vous n'avez pas accès à la page demandée.</div>
    )
}

export default Unauthorized